import type MailListColumnHeaderType from "../types/MailListColumnHeaderType";
import { type SortColumn, getSortByForTable, isCopilotResultsTable, type TableView, type TableQueryType } from "owa-mail-list-store";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
/**
 * Gets the sort HeaderType for the given table to
 * add the new sort
 * @param tableView for which to find the sortBy
 * @returns the sortHeaderType property for the given table
 */
export default function getSortedContentColumnHeaderType(tableView: TableView): MailListColumnHeaderType | null {
    if (!isGlobalFeatureEnabled("tri-sortFilter4thColumn") ||
        tableView.tableQuery.type === 1 ||
        isCopilotResultsTable(tableView.tableQuery)) {
        return null;
    }
    const sortBy = getSortByForTable(tableView);
    if (sortBy.sortColumn &&
        (sortBy.sortColumn === 14 ||
            sortBy.sortColumn === 5 ||
            sortBy.sortColumn === 2 ||
            sortBy.sortColumn === 17 ||
            sortBy.sortColumn === 16 ||
            sortBy.sortColumn === 7)) {
        switch (sortBy.sortColumn) {
            case 14:
                return 3;
            case 5:
                return 4;
            case 16:
                return 5;
            case 2:
                return 6;
            case 17:
                return 7;
            case 7:
                return 8;
            default:
                return null;
        }
    }
    return null;
}
